// extracted by css-extract-rspack-plugin
export default {"left-item-wrapper":"XOtbra","leftItemWrapper":"XOtbra"};